import { StyleSheet } from 'react-native'

export const useStyles = (theme) => StyleSheet.create({
  card: {
    marginTop: 10,
    marginBottom: 20
  },
  cardContent: {
    backgroundColor: theme.CARD_BACKGROUND
  },
  dividerContainer: {
    flexDirection: 'row',
    alignItems: 'center'
  },
  divider: {
    marginVertical: 10,
    flex: 1
  },
  stopsNumber: {
    width: 36,
    height: 36,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.CATSKILL_WHITE,
    borderRadius: 50,
    marginLeft: 10
  },
  closeArrow: {
    alignItems: 'center',
    width: '100%'
  }
})

export default useStyles
